module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_NL-a227421d0579a70ea6a117a4c82be8e5.svg";